import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAuthToken } from "../services/apiClient";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const VISITOR_KEY = "circuit_visitor_id";

function visitorId() {
  let id = window.localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = window.crypto?.randomUUID?.() || `visitor-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export default function VisitorPresence() {
  const location = useLocation();
  useEffect(() => {
    let cancelled = false;
    async function heartbeat() {
      if (cancelled) return;
      await fetch(`${API_BASE}/analytics/heartbeat`, { method: "POST", headers: { "Content-Type": "application/json", ...(getAuthToken() ? { Authorization: `Bearer ${getAuthToken()}` } : {}) }, body: JSON.stringify({ visitorId: visitorId(), page: `${location.pathname}${location.search}` }) }).catch(() => {});
    }
    heartbeat();
    const interval = window.setInterval(heartbeat, 60_000);
    return () => { cancelled = true; window.clearInterval(interval); };
  }, [location.pathname, location.search]);
  return null;
}